export const ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS';
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
